import { useMemo } from "react";
import { createApiClient, type ApiClient } from "../api/client.ts";
import { resolveDeviceToken, resolveDeviceId } from "../config/device.ts";

export function useApiClient(): ApiClient {
  return useMemo(() => createApiClient({
    apiBase: import.meta.env.VITE_API_BASE_URL,
    deviceToken: resolveDeviceToken(),
    deviceId: resolveDeviceId(),
  }), []);
}
